import './utils/fix-file-saver';
import saveAsFile from 'file-saver'; // eslint-disable-line import/first
import deprecate from './utils/deprecate';
import { MOBILE_V1 } from './utils/endpoints';

/* eslint-disable id-length */

export default (_ref, updateContext, getContext) => {
  var shared = _ref.shared,
    _ref$endpoints = _ref.endpoints,
    endpoints = _ref$endpoints === void 0 ? {} : _ref$endpoints,
    _ref$onAddToWatchlist = _ref.onAddToWatchlist,
    onAddToWatchlist = _ref$onAddToWatchlist === void 0 ? () => {} : _ref$onAddToWatchlist;
  var apiClient = shared.apiClient,
    getAbsoluteUrl = shared.getAbsoluteUrl;
  var postWithToken = apiClient.postWithToken;
  var _endpoints$watchlistE = endpoints.watchlistEndpoint,
    watchlistEndpoint = _endpoints$watchlistE === void 0 ? "".concat(MOBILE_V1, "/watchlist") : _endpoints$watchlistE;
  var endpoint = action => "".concat(getAbsoluteUrl(watchlistEndpoint), "/").concat(action);
  var ADD = endpoint('add');
  var REMOVE = endpoint('remove');
  var ADD_NOTE = endpoint('addNote');
  var REMOVE_NOTE = endpoint('removeNote');
  var FETCH = endpoint('fetch');
  var EXPORT = endpoint('export');
  var addListingToWatchlist = listingId => postWithToken(ADD, {
    listingId
  }).then(_ref2 => {
    var watchlist = _ref2.watchlist;
    // successfully added, update the context for observers
    updateContext({
      watchlist
    });
    // and any callbacks
    onAddToWatchlist(listingId);
    return watchlist;
  });
  var removeListingFromWatchlist = listingId => postWithToken(REMOVE, {
    listingId
  }).then(_ref3 => {
    var watchlist = _ref3.watchlist;
    // successfully removed, update the context for observers
    updateContext({
      watchlist
    });
    return watchlist;
  });
  var isInWatchlist = id => {
    var context = getContext();
    return context && new Set(context.watchlist || []).has(id);
  };
  var updateWatchlist = (id, fromState) => {
    var currentState = fromState == null ? isInWatchlist(id) : fromState;
    return currentState ? removeListingFromWatchlist(id) : addListingToWatchlist(id);
  };
  var addNote = _ref4 => {
    var notesId = _ref4.notesId,
      notes = _ref4.notes;
    return postWithToken(ADD_NOTE, {
      notesId,
      notes
    });
  };
  var removeNote = _ref5 => {
    var notesId = _ref5.notesId;
    return postWithToken(REMOVE_NOTE, {
      notesId
    });
  };
  var fetchFullWatchlist = function fetchFullWatchlist() {
    var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      sortOrder: 'asc',
      sortCriteria: 'price'
    };
    return postWithToken(FETCH, payload);
  };
  var downloadWatchlist = function downloadWatchlist() {
    var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var filename = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'watchlist.csv';
    return postWithToken(EXPORT, payload, {
      blob: true
    }).then(blob => saveAsFile(blob, filename));
  };
  return {
    watchlist: [],
    addListingToWatchList: deprecate.function(addListingToWatchlist, 'Use addListingToWatchlist instead'),
    addListingToWatchlist,
    removeListingFromWatchList: deprecate.function(removeListingFromWatchlist, 'Use removeListingFromWatchlist instead'),
    removeListingFromWatchlist,
    isInWatchList: deprecate.function(isInWatchlist, 'Use isInWatchlist instead'),
    isInWatchlist,
    updateWatchList: deprecate.function(updateWatchlist, 'Use updateWatchlist instead'),
    updateWatchlist,
    fetchFullWatchlist,
    downloadWatchlist,
    addNote,
    removeNote
  };
};